import type { ReactNode } from "react";
import { Icon } from "../lib/Icon";
import { NAV } from "../app/nav";

/** Standard scrollable page wrapper — 24px 28px padding, 16px gaps (§9). */
export function Page({ children }: { children: ReactNode }) {
  return (
    <div style={{ overflowY: "auto", padding: "24px 28px 40px", display: "flex", flexDirection: "column", gap: 16, height: "100%" }}>
      {children}
    </div>
  );
}

export function Loading() {
  return <div style={{ padding: 28, color: "#8a8e88", fontSize: 13 }}>Loading…</div>;
}

export function ErrorNote({ error }: { error: unknown }) {
  return (
    <div style={{ margin: 28, padding: "12px 14px", background: "#fbe9e7", border: "1px solid #f3d3ce", borderRadius: 6, color: "#b3261e", fontSize: 13 }}>
      Couldn’t load this data — {error instanceof Error ? error.message : String(error)}
    </div>
  );
}

/** Placeholder for screens that are scaffolded but not yet fully built. */
export function Scaffold({ id }: { id: string }) {
  const item = NAV.find((n) => n.id === id);
  return (
    <Page>
      <div>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 600, letterSpacing: "-0.6px" }}>{item?.label ?? "Screen"}</h1>
        <div style={{ fontSize: 14, color: "#8a8e88", marginTop: 3 }}>Scaffolded — API and data model in place; UI build-out is a later delivery phase.</div>
      </div>
      <div style={{ background: "#fff", borderRadius: 3, boxShadow: "inset 0 0 0 1px rgba(0,0,0,.07)", padding: "18px 20px", maxWidth: 760 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
          <span style={{ width: 30, height: 30, borderRadius: 6, background: "#e8f4ee", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Icon name={item?.icon ?? "circle"} size={16} color="#006747" />
          </span>
          <span style={{ fontSize: 15, fontWeight: 600 }}>Purpose</span>
        </div>
        <div style={{ fontSize: 13.5, lineHeight: 1.6, color: "#4a504a" }}>{item?.purpose}</div>
      </div>
    </Page>
  );
}
